import React from 'react';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {DOCUMENTS_HOME} from 'app/urls';

export function isWelcomeAppExitUrl(url: string): boolean {
  return url === DOCUMENTS_HOME;
}

type Props = {
  className?: string;
  children: React.ReactNode;
};

// Full-page link from onboarding into the main app (unloads welcome GTM)
export function WelcomeExitLink({className, children}: Props) {
  return (
    <FullHTMLLink
      html_url={DOCUMENTS_HOME}
      renderRegularLink
      className={className}
    >
      {children}
    </FullHTMLLink>
  );
}
